import { Status } from './models';

export class OrderLineStatus extends Status {
  // This is the name used as module name of the Vuex Store.
  static entity = 'order_line_statuses';

  static fields() {
    return {
      ...super.fields(),
    };
  }
}

export default OrderLineStatus;
